// extracted by mini-css-extract-plugin
export default {"exponentContainer":"unJugEto65IfdcH0KHCj","organization":"OabTakFS_2PZRcvlnhkI","modulesContainer":"L_ygbWKd1Pq0SAfUHDnX"};